/**
 * Route copy for `src/routes/geo` (keys: `routes.geo.<file>.<key>`).
 *
 * `fr` is the source; `en` and `ar` are typed against it, so a missing or extra
 * key fails `tsc` (and parity.test.ts). Keys are referenced from the route files
 * through `t()` / `tr()` — edit values freely, never rename a key without its call site.
 *
 * Locale file: en (typed against ./fr). One file per locale so
 * every non-default locale is a separate, lazily-loaded chunk.
 */

import type { Catalog } from './fr';

const en: Catalog = {
  geoHubPage: {
    copilot: 'Copilot',
    remove: 'Remove',
    geoAnalysisFailed: 'GEO analysis failed.',
    prompt: 'Prompt',
    engine: 'Engine',
    brandCited: 'Brand cited',
    yes: 'Yes',
    no: 'No',
    brandsCited: 'Brands cited',
    excerpt: 'Excerpt',
    yourBrand: 'Your brand',
    eGKarexia: 'e.g. Karexia',
    competitors: 'Competitors',
    optionalUsedToSpotWhoElse: 'Optional — used to spot who else is cited.',
    eGCompetitorA: 'e.g. Competitor A',
    addACompetitor: '+ Add a competitor',
    prompts: 'Prompts',
    theQuestionsSentToEachEngine: 'The questions sent to each engine, e.g. “What is the best social media management tool?”',
    typeAPrompt: 'Type a prompt…',
    addAPrompt: '+ Add a prompt',
    aiEngines: 'AI engines',
    analysisInProgress: 'Analysis in progress…',
    runTheAnalysis: 'Run the analysis',
    result: 'Result',
    noResults: 'No results',
    runAnAnalysisToSeeThe: 'Run an analysis to see the share of voice and the citations per prompt.',
    queryingTheAiEngines: 'Querying the AI engines…',
    citationRate: 'Citation rate',
    leaderShareOfVoice: 'Leader (share of voice)',
    geoHistoryUnavailable: 'GEO history unavailable.',
    citationRateOverTime: 'Citation rate over time',
    refresh: 'Refresh',
    noHistory: 'No history',
    runAnalysesOverTimeToSee: 'Run analyses over time to see the citation rate trend.',
    loadingTheHistory: 'Loading the history…',
    geoDiagnosisFailed: 'GEO diagnosis failed.',
    domainGeoDiagnosis: 'Domain GEO diagnosis',
    domain: 'Domain',
    eGExampleCom: 'e.g. example.com',
    exampleCom: 'example.com',
    diagnosisInProgress: 'Diagnosis in progress…',
    runTheDiagnosis: 'Run the diagnosis',
    noDiagnosisYet: 'No diagnosis yet',
    enterADomainThenRunThe: 'Enter a domain, then run the diagnosis to assess its GEO/AEO readiness.',
    technicalAnalysisOfTheDomain: 'Technical analysis of the domain…',
    geoScore: 'GEO score',
    noObservation: 'No observation.',
    geoAeo: 'GEO / AEO',
    measureAndTrackYourPresenceIn: 'Measure and track your presence in AI engine answers (ChatGPT, Perplexity, Gemini…): share of voice, citation rate per prompt, trend over time, and a technical GEO readiness diagnosis for your domain.',
  },
};

export default en;
